import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "./FontAwesomeIcon";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import "./new-dora-inputs.scss";
import { Autocomplete, TextField, IconButton } from "@mui/material";
import { Controller } from "react-hook-form";
const UFDoraMultilineTextAutocomplete = ({ name, control, options, onDeleteOption, error, disabled, placeholder, className, id, icon, "aria-label": ariaLabel, }) => {
    const wrapperClasses = classnames("dora-text-input-wrapper", disabled ? "dora-text-input-wrapper--disabled" : null, error ? "dora-text-input-wrapper--error" : null, className);
    return (_jsx(Controller, { name: name, control: control, render: ({ field: { ref, onChange, onBlur, value } }) => (_jsxs("div", { className: wrapperClasses, children: [icon && (_jsx("div", { className: "dora-text-input__icon", children: _jsx(FontAwesomeIcon, { icon: icon }) })), _jsx(Autocomplete, { freeSolo: true, disableClearable: true, forcePopupIcon: false, options: options, value: value ?? "", inputValue: value ?? "", onChange: (_, newValue) => {
                        onChange(newValue ?? "");
                    }, onInputChange: (_, newValue, reason) => {
                        if (reason === "reset")
                            return;
                        onChange(newValue);
                    }, sx: { display: "block", width: "100%" }, renderOption: (props, option) => (_createElement("li", { ...props, key: option, style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        } },
                        _jsx("span", { style: {
                                flex: 1,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }, children: option }),
                        _jsx(IconButton, { size: "small", onMouseDown: (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onDeleteOption?.(option);
                            }, children: _jsx(FontAwesomeIcon, { icon: faTimes }) }))), renderInput: (params) => (_jsx(TextField, { ...params, inputRef: ref, multiline: true, minRows: 1, disabled: disabled, placeholder: placeholder, id: id, inputProps: { ...params.inputProps, "aria-label": ariaLabel }, onBlur: onBlur, sx: {
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                                padding: "0.625rem 0.875rem",
                                paddingLeft: icon
                                    ? "calc(0.875rem + 1.375rem)"
                                    : "0.875rem",
                                border: error
                                    ? "2px solid var(--error-500)"
                                    : "0.0625rem solid var(--gray-300)",
                                borderRadius: "0.1875rem",
                                background: disabled ? "var(--gray-100)" : "white",
                                cursor: disabled ? "not-allowed" : "auto",
                                "&:hover": {
                                    borderColor: disabled
                                        ? "var(--gray-300)"
                                        : error
                                            ? "var(--error-500)"
                                            : "var(--gray-400)",
                                },
                                "&.Mui-focused": {
                                    borderColor: error
                                        ? "var(--error-500)"
                                        : "var(--gray-300)",
                                },
                                "& .MuiOutlinedInput-notchedOutline": { display: "none" },
                            },
                            "& .MuiInputBase-inputMultiline": {
                                padding: 0,
                                fontSize: "16px",
                                fontFamily: "Arial",
                                color: disabled ? "var(--gray-400)" : "var(--gray-900)",
                                resize: "none",
                                "&::placeholder": { color: "var(--gray-400)" },
                            },
                        } })) })] })) }));
};
export { UFDoraMultilineTextAutocomplete };
//# sourceMappingURL=DoraMultilineTextAutocomplete.js.map